<script lang="ts" setup>
const props = defineProps<{
  user: Author
  size?: 'mini' | 'small' | 'medium' | 'large'
  custom?: boolean
  noAvatar?: boolean
  info?: string
  fans?: number
  follow?: boolean
  followStatus?: number
  highlight?: string
  row?: number
}>()

const avatarSizeMap = {
  mini: '16',
  small: '24',
  medium: '32',
  large: '64'
}

const avatarMarginRightMap = {
  mini: '4px',
  small: '6px',
  medium: '8px',
  large: '12px'
}

const authSizeMap = {
  mini: '8px',
  small: '10px',
  medium: '14px',
  large: '18px'
}

const nameSizeMap = {
  mini: '12px',
  small: '14px',
  medium: '16px',
  large: '18px'
}
</script>

<template>
  <m-link :to="`/member/${user.id}`" :title="user.name" class="m-user">
    <div
      v-if="!noAvatar"
      class="m-user__avatar"
      :style="{
        width: avatarSizeMap[size || 'medium'] + 'px',
        height: avatarSizeMap[size || 'medium'] + 'px',
        marginRight: avatarMarginRightMap[size || 'medium']
      }"
    >
      <MAvatar
        :id="user.id"
        :size="avatarSizeMap[size || 'medium']"
        :src="user.avatar"
      />
      <n-popover v-if="user.user_auth" trigger="hover">
        <template #trigger>
          <img
            v-if="user.user_auth"
            :src="`https://resource.mfuns.net/imgs/auth/${user.user_auth.type}.svg`"
            alt="auth"
            class="m-user__auth-badge"
            :style="{
              width: authSizeMap[size || 'medium'],
              height: authSizeMap[size || 'medium']
            }"
          />
        </template>
        <div>{{ user.user_auth?.name }} {{ user.user_auth?.desc }}</div>
      </n-popover>
    </div>
    <div v-if="!custom" class="m-user__info">
      <div
        class="m-user__name highlight"
        :style="{
          fontSize: nameSizeMap[size || 'medium'],
          color: user.name_color
        }"
      >
        <span v-html="highlight || user.name"></span>
        <m-badge :badges="user.badges" />
      </div>
      <div v-if="fans != undefined">
        <m-text inline secondary>粉丝数&nbsp;&nbsp;</m-text>
        <m-text inline>
          {{ pipe.num(fans) }}
        </m-text>
      </div>
      <m-text
        v-if="!['mini', 'small'].includes(size || 'medium')"
        ellipsis
        tertiary
        :row="row ?? 1"
      >
        {{ info || user.info }}
      </m-text>
      <m-follow-button v-if="follow" :id="user.id" :status="followStatus" />
    </div>
    <div v-else class="m-user__info">
      <slot />
    </div>
  </m-link>
</template>

<style lang="scss" scoped>
.m-user {
  display: flex;
  &__avatar {
    position: relative;
    flex-shrink: 0;
  }
  &__auth-badge {
    position: absolute;
    background: #fff;
    border-radius: 50%;
    outline: 2px solid #fff;
    bottom: 0;
    right: 0;
    z-index: 100;
    height: 18px;
    width: 18px;
  }
  &__name {
    font-size: 18px;
    display: flex;
    align-items: center;
  }
}
</style>
